import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_DISH_TYPES_MUTATION } from '../graphql/mutations'
import { transformToSaveDishTypesArgs } from '../graphql/transformers'
import { SAVE_DISH_TYPES } from '../redux/action-types'

const useSaveDishTypesMutation = refetchLastEvent => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.dishTypes.dishTypes)

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_DISH_TYPES_MUTATION,
        { data: transformToSaveDishTypesArgs(data) },
        dispatch,
        SAVE_DISH_TYPES,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveDishTypesMutation
